import React, { Component } from "react";
import Axios from "axios";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "./ManageFeeDetails.css";
import { engMonths } from "../../../../../Components/Data/Months";
import { url } from "../../../../../Config/Config";
import ViewFeeForm from "./ViewFeeForm/ViewFeeForm";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class ManageFeeDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentFeeDetails: {},
      monthName: null,
      feesData: [],
    };
  }

  componentDidMount() {
    if (this.props.studentFeeId) {
      this.getStudentFee(this.props.studentFeeId);
    }
  }

  getStudentFee = async (studentFeeId) => {
    try {
      const response = await Axios.get(
        `${url}/api/student-fees/${studentFeeId}`,
        {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        }
      );
      if (response.data.studentFees) {
        this.setState({
          studentFeeDetails: response.data.studentFees,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStudentFee(studentFeeId);
      }
    }
  };

  checkFees = (monthName) => {
    this.setState({
      feesData: this.checkFees(monthName),
    });
  };

  handleChangeMonth = (value) => {
    this.setState({
      monthName: value,
    });
    this.setFee(value);
  };

  checkFees = (monthName) => {
    let filteredData = this.state.studentFeeDetails.fees.filter(
      (filter) => filter.month.indexOf(monthName) !== -1
    );
    if (filteredData.length !== 0) {
      this.setState({
        feesData: filteredData,
      });
      return true;
    } else {
      this.setState({
        feesData: [],
      });
      return false;
    }
  };

  setFee = async (monthName) => {
    try {
      let feesData = this.checkFees(monthName);
      if (feesData === false) {
        let fees = this.state.studentFeeDetails.fees;
        for (let i = 0; i <= this.props.initialFeeGroup.length - 1; i++) {
          fees.push({
            month: monthName,
            feeTypeName: this.props.initialFeeGroup[i].feeTypeName,
            price: this.props.initialFeeGroup[i].price,
          });
        }
        const response = await Axios.post(
          `${url}/api/student-fees/${this.state.studentFeeDetails.admissionId}/fee`,
          { fees: fees },
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.studentFee) {
          this.getStudentFee(this.props.studentFeeId);
          this.checkFees(monthName);
        }
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.setFee(monthName);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { studentFeeDetails } = this.state;
    return (
      <Paper className={classes.root}>
        <div>
          <CancelIcon onClick={this.props.handleCancelShowDetails} />
        </div>
        <div className={classes.listitemRoot}>
          <div className={classes.listitemContent}>
            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Session:</b>
              <div>{studentFeeDetails.session}</div>
            </ListItem>
            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Class</b>
              <div>{studentFeeDetails.studentClass}</div>
            </ListItem>
            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Section</b>
              <div>{studentFeeDetails.section}</div>
            </ListItem>
          </div>
          <div className={classes.listitemContent}>
            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Admission ID:</b>
              <div>{studentFeeDetails.admissionId}</div>
            </ListItem>

            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Faculty</b>
              <div>
                {studentFeeDetails.faculty ? studentFeeDetails.faculty : "N/A"}
              </div>
            </ListItem>
          </div>
          <div className={classes.listitemContent}>
            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Student's Name</b>
              <div>{studentFeeDetails.studentName}</div>
            </ListItem>
            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Group</b>
              <div>
                {studentFeeDetails.group ? studentFeeDetails.group : "N/A"}
              </div>
            </ListItem>
          </div>
        </div>
        <br />
        <div className={classes.filterSelect}>
          <Autocomplete
            id="district combo-box-demo"
            value={this.state.monthName}
            onChange={(event, value) => {
              if (value && value) {
                this.handleChangeMonth(value);
              }
            }}
            options={engMonths}
            getOptionLabel={(option) => (option ? option : null)}
            defaultValue={null}
            getOptionSelected={(option, value) => {
              if (!value) return false;
              return option === value;
            }}
            renderInput={(params) => (
              <TextField
                style={{ background: "white", width: "100%" }}
                {...params}
                variant="outlined"
                placeholder="Select Months"
                name="district"
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
              />
            )}
          />
        </div>
        {this.state.feesData.length !== 0 && (
          <ViewFeeForm
            studentFeeDetails={this.state.studentFeeDetails}
            monthName={this.state.monthName}
            checkFees={this.checkFees}
            studentFeeId={this.props.studentFeeId}
            getStudentFee={this.getStudentFee}
            feesData={this.state.feesData}
            initialFeeGroup={this.props.initialFeeGroup}
          />
        )}
      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ManageFeeDetails));
